import api from '@/api'

export default {

    getDataSet: (token: string, type: string, unit: string, year: string, yearMonth: string): Promise<powerbi.DatasetExecuteQueriesResponse> => {
        return api.get<powerbi.DatasetExecuteQueriesResponse>({
            url: '/yek/powerbi/dataset',
            params: {
                type: type,
                unit: unit,
                year: year,
                yearMonth: yearMonth,
            },
            headers: {
                'Eum-Bi-Token': token
            }
        });
    }
}